// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Typography } from '@mui/material';
import { extractPrefix } from '../utils/common';
import CopyToClipboard from './CopyToClipboard';

const PartyDisplay = ({ party }: { party: string }) => {
  return (
    <CopyToClipboard buttonClassName="copy-button" tooltipText="Copy to clipboard" value={party}>
      <Typography color="textPrimary" variant="body2">
        {extractPrefix(party, '::')}
      </Typography>
    </CopyToClipboard>
  );
};

export default PartyDisplay;
